module.exports = __webpack_public_path__ + "img/logo.1e98c329.svg";